import { Type } from 'class-transformer';
import { IsDate, IsInt, Min } from 'class-validator';
import { AuditFormDto } from './auditForm.dto';
import { AuditFormFrequencyDto } from './auditFormFrequency.dto';
import { AuditFormScheduleQuestionResponseDto } from './auditFormScheduleQuestionResponse.dto';
import { AuditFormScheduleStatusDto } from './auditFormScheduleStatus.dto';
import { AuditFormStatusDto } from './auditFormStatus.dto';
import { BaseDto } from '../base.dto';
import { UserDto } from '../user.dto';

export class AuditFormScheduleDto extends BaseDto {
  auditForm: AuditFormDto;
  auditFormStatus: AuditFormStatusDto;

  @Type(() => UserDto)
  user: UserDto;

  @IsDate()
  @Type(() => Date)
  startDate: Date;

  auditFormFrequency: AuditFormFrequencyDto;

  @IsInt()
  @Min(1)
  noOfQuestions: number;

  auditFormScheduleStatus: AuditFormScheduleStatusDto;

  @IsDate()
  @Type(() => Date)
  completedDate?: Date;

  @IsInt()
  completedDateAsInt?: number;

  @IsInt()
  scheduledDateAsInt?: number;

  auditFormScheduleResponses: AuditFormScheduleQuestionResponseDto[];

  scheduledDate?: Date;

  managerOnDuty?: string;
}
